<template>
  <div no-body class="lku-angsuran">
    <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color:blue;">Loading data ...</span>
    </b-row>
    <div v-else>
      <b-row>
        <b-col md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Agreement No</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.agreement" placeholder="Agreement No" @keyup.13.native="refresh()"
              style="width:30% !important;"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>No.Kontrak</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" placeholder="No.Kontrak"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.customer" placeholder="Debitur Name / Customer No"
              @keyup.13.native="refresh()" style="width:30% !important;"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Project</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="sourceproject"></b-form-select>
          </b-input-group>

          <b-input-group>

            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <b-card no-body>
      <b-table class="mb-0" ref="tblArinvOst" style="font-size:smaller;" responsive small striped hover :items="data"
        :fields="fields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="selectItem" show-empty>
        <template v-slot:cell(tgl_kontrak)="data">{{ data.item.tgl_kontrak | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(plafon)="data">{{ data.item.plafon | numFormat('0,0.00') }}</template>
        <template v-slot:cell(bunga_tarifthn)="data">{{ data.item.bunga_tarifthn | numFormat('0,0.00') }}</template>
        <template v-slot:cell(installment_amount)="data">{{ data.item.installment_amount | numFormat('0,0.00')
          }}</template>
        <template v-slot:cell(tenor)="data">{{ data.item.tenor | numFormat('0,0') }}</template>
        <template v-slot:cell(bungaod_tarifthn)="data">{{ data.item.bungaod_tarifthn | numFormat('0,0.00') }}</template>
        <template v-slot:cell(tglpelunasan)="data">{{ data.item.tglpelunasan | moment("DD/MM/YYYY") }}</template>
        <template v-slot:empty="scope">
          <h6 class="text-center mt-2 mb-2">{{ scope.emptyText }}</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6 class="text-center mt-2 mb-2">{{ scope.emptyFilteredText }}</h6>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="3">
          <b-row class="ml-2 mt-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
              style="width:80px !important;" />
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style lang="scss">
.lku-angsuran {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
}
</style>

<script>
import pinjaman from "../../apis/pinjamankredit";
import project from "../../apis/project";


export default {
  data() {
    return {
      lkuLoading: false,
      fields: [
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          tdClass: "ml-1",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Aggrement",
          thStyle: "width:140px",
          tdClass: "ml-1",
          sortable: true,
        },
        {
          key: "tgl_kontrak",
          label: "Tgl. Buka",
          thStyle: "width:90px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur",
          sortable: true,
        },
        {
          key: "cessie_ccy",
          label: "Cassie Currency",
          sortable: true,
        },
        {
          key: "model_pinjaman",
          label: "Model",
          sortable: true,
        },
        {
          key: "bunga_tarifthn",
          label: "Bunga(%)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tenor",
          label: "Jk.Waktu",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "installment_amount",
          label: "Angsuran/bulan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "pjxcode",
          label: "Project",
          thClass: "text-center",
          tdClass: "text-right",
        }
      ],
      tblData: {
        items: [],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        nomor: "",
        outstand: "1",
        agreement: "", customer: '',pjxkey:''
      },
      sourceproject: [],
      updatetable: false,
    };
  },
  props: ["modelpinjaman", "nasabahkey"],
  async created() {
    if ((this.modelpinjaman || "") !== "") {
      this.tblData.model_pinjaman = this.modelpinjaman;
    }
    if ((this.nasabahkey || "") !== "") {
      this.tblData.nasabahkey = this.nasabahkey;
    }

    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce((arr = [{
        value: '',
        text: '-- ALL -- ',
      }], item, index) => {
      arr.push({
        value: item.pjxkey,
        text: item.pjxname,
      });
      return arr;
    }, [{
        value: '',
        text: '-- ALL -- ',
      }]);

    if (this.sourceproject.length == 1) this.tblData.pjxkey = this.sourceproject[0].value

  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const list = await pinjaman.list(this.tblData);
      this.lkuLoading = false;
      return list;
    },
    selectItem(item, index) {
      // this.$emit("click", item);
      this.$emit("click", item);
    },
    clearFilter() {
      // this.customer= '';
      // this.nomor=  '';
      this.tblData.customer = "";
      this.tblData.nomor = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
    },
    keymonitor: function (event) {
      if (event.key == "Enter") {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblArinvOst.refresh();
      }
    },
    refresh() {
      this.data();
      this.$refs.tblArinvOst.refresh();
    },
  },
};
</script>
